module.exports = __webpack_public_path__ + "img/expand.f75ca24d.png";